import FormContentCreateOrEditCreatorPaymentMethod from './FormContentCreateOrEditCreatorPaymentMethod';

export default FormContentCreateOrEditCreatorPaymentMethod;
